import React, { Component } from 'react'
import { Tooltip, Modal } from 'hljd'
import { Auth } from '@common/Auth'
import { PRIVILEGE_GROUP_ID, REALNAME_AUTH_PATH } from '@constant'
import { hashHistory } from 'react-router'

@Auth({ role: [PRIVILEGE_GROUP_ID] })
export default class extends Component {
  render() {
    const { data } = this.props
    const hasTag = data == 1

    return (
      <Tooltip
        title={`通过「营业执照」进行认证的团队，会在用户端显示“V认证”标志。`}
      >
        <img
          src={
            hasTag
              ? '//qnm.hunliji.com/o_1diulk139enf1fheltb15cp1jf8a.png'
              : '//qnm.hunliji.com/o_1diulk139jds197lbct15jv152mb.png'
          }
          onClick={() => {
            if (!hasTag) {
              Modal.confirm({
                title: `通过「营业执照」进行认证的团队，会在用户端显示“V认证”标志`,
                okText: '立即认证',
                cancelText: '遗憾放弃',
                onOk: () => {
                  hashHistory.push(REALNAME_AUTH_PATH)
                }
              })
            }
          }}
        />
      </Tooltip>
    )
  }
}
